(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-minimal"] && !Shopify.designMode) return;
  try {
    
  /* Minimal footer: slide the mobile dropdowns open and closed. */
  if (!window.footerMinimalAccordion) {
    window.footerMinimalAccordion = true;

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.footer-minimal__item > summary');
      if (!summary) return;

      const details = summary.parentElement;
      const panel = details.querySelector('.footer-minimal__panel');
      if (!panel || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      event.preventDefault();

      const closing = details.open && !details.classList.contains('is-closing');
      const startHeight = details.open ? panel.getBoundingClientRect().height : 0;

      details.footerAnimation?.cancel();
      details.classList.toggle('is-closing', closing);
      details.open = true;

      const endHeight = closing ? 0 : panel.scrollHeight;
      const animation = panel.animate(
        [
          { height: `${startHeight}px`, opacity: closing ? 1 : 0 },
          { height: `${endHeight}px`, opacity: closing ? 0 : 1 },
        ],
        { duration: 350, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );
      details.footerAnimation = animation;

      animation.onfinish = () => {
        details.footerAnimation = null;
        if (closing) {
          details.open = false;
          details.classList.remove('is-closing');
        }
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-locations')) {
    /* Adds click-and-drag scrolling for mouse users; touch and trackpads use native scrolling. */
    class StoreLocations extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.store-locations__track');
        if (!this.track) return;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClick = this.onClick.bind(this);

        this.track.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('click', this.onClick, true);
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('pointerdown', this.onPointerDown);
        this.track.removeEventListener('click', this.onClick, true);
        this.onPointerUp();
      }

      onPointerDown(event) {
        this.dragged = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.startX = event.clientX;
        this.startScroll = this.track.scrollLeft;
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
      }

      onPointerMove(event) {
        const delta = event.clientX - this.startX;
        if (!this.dragged && Math.abs(delta) < 5) return;
        this.dragged = true;
        this.track.classList.add('is-dragging');
        this.track.scrollLeft = this.startScroll - delta;
      }

      onPointerUp() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        if (!this.track.classList.contains('is-dragging')) return;

        // Restore snapping, then settle on the nearest card.
        const scroll = this.track.scrollLeft;
        this.track.classList.remove('is-dragging');
        this.track.scrollLeft = scroll;
      }

      onClick(event) {
        // Don't follow a card link when the click ends a drag.
        if (this.dragged) {
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }
      }
    }

    customElements.define('store-locations', StoreLocations);
  }

  } catch(e) { console.error(e); }
})();
})();
